import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-addlead',
    templateUrl: './addlead.component.html',
    styleUrls: ['./addlead.component.css'],
    standalone: false
})
export class AddleadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
